import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { Skeleton, createMqStyles, tokens, useMqSelect } from '@fhs/ui';

interface Props {
  hideMobileButton?: boolean;
  style?: StyleProp<ViewStyle>;
}

export function RewardTierCardSkeleton({ style, hideMobileButton }: Props) {
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);

  const styles = useMqStyles();
  return (
    <View style={[styles.container, style]}>
      <View style={styles.headerRow}>
        <Skeleton style={styles.imageContainer} />

        <View style={styles.textContainer}>
          {isDesktop && <Skeleton style={styles.pointsBadge} />}
          <Skeleton style={styles.title} />
          <Skeleton style={styles.description} />
        </View>
      </View>

      {(isDesktop || !hideMobileButton) && <Skeleton style={styles.redeemButton} />}
    </View>
  );
}

const useMqStyles = createMqStyles({
  container: {
    $base: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderWidth: 1,
      borderRadius: 8,
      borderColor: tokens.colors.$blackOpacity10,
    },
    $gteDesktop: {
      paddingVertical: 24,
      paddingHorizontal: 28,
      flexDirection: 'row',
    },
  },
  headerRow: {
    $base: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
  },
  imageContainer: {
    $base: {
      backgroundColor: tokens.colors.$houseLight,
      borderRadius: 4,
      padding: 4,
    },
    $ltDesktop: {
      height: 46,
      width: 46,
    },
    $gteDesktop: {
      height: '100%',
      aspectRatio: 1,
      maxHeight: 70,
    },
  },
  textContainer: {
    $base: {
      marginLeft: 12,
      flex: 1,
    },
  },
  pointsBadge: {
    $base: {
      marginBottom: 4,
      height: 20,
      width: 70,
      backgroundColor: tokens.colors.$houseLight,
    },
  },
  title: {
    $base: {
      backgroundColor: tokens.colors.$houseLight,
      height: 16,
      width: 100,
    },
  },
  description: {
    $base: {
      marginTop: 4,
      backgroundColor: tokens.colors.$houseLight,
      height: 14,
      width: '75%',
    },
  },
  redeemButton: {
    $base: {
      height: 35,
      backgroundColor: tokens.colors.$houseLight,
      marginTop: 12,
    },
    $gteDesktop: {
      width: 100,
    },
  },
});
